import { ConditionCategory } from '@quirion/types';

/**
 * Product categories that follow the glide path: their equity share is reduced
 * automatically as retirement approaches (SCIR-824), and a manual strategy change
 * is not offered for them.
 *
 * `PensionPlan` (`AV.AV`) is the *legacy* pension product — it keeps its manual
 * strategy change and must stay out of this list.
 */
const GLIDE_PATH_CONDITION_CATEGORIES: ConditionCategory[] = [
  ConditionCategory.PensionNewGlobal,
  ConditionCategory.PensionNewSustainable,
];

export const isGlidePathCategory = (category?: string | null): boolean =>
  !!category &&
  GLIDE_PATH_CONDITION_CATEGORIES.includes(category as ConditionCategory);
